import { css } from '@emotion/react';
import { SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  margin-top: 56px;
  padding: 0 var(${SpacingToken.Spacing5});
  gap: var(${SpacingToken.Spacing3});

  ${MEDIA_MIN_SM} {
    margin-top: 118px;
  }
`;

export const formField = css`
  width: 100%;
  max-width: 360px;
  margin-top: 16px;
`;

export const button = css`
  width: 100%;
  max-width: 360px;
  margin-bottom: var(${SpacingToken.Spacing4});
`;
